import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Selector, SelectorItems, SelectorItemsDisableReason } from '../Selector/Selector';

import * as keyset from './CampaignSelector.i18n';

const i18n = i18nFactory(keyset);

export interface CampaignSelectorProps {
    items?: Array<SelectorItems>;
    onInputChange: (text: string) => void;
    onItemSelect: (selectorItems: SelectorItems) => void;
    inputText?: string;
    error?: boolean;
    itemSelected?: SelectorItems;
    isActive: boolean;
    isLoading: boolean;
    itemsLimit: number;
}

export const CampaignSelector = ({
    error,
    items,
    onInputChange,
    inputText,
    onItemSelect,
    isActive,
    itemSelected,
    isLoading,
    itemsLimit
}: CampaignSelectorProps) => (
    <Selector
        items={items}
        cls={Bem.cls('campaign-selector')}
        onInputChange={onInputChange}
        onItemSelect={onItemSelect}
        placeholder={i18n('search-by-campaign')}
        emptyText={i18n('no-campaign-found')}
        errorText={error ? i18n('error') : ''}
        itemSelected={itemSelected}
        isLoading={isLoading}
        inputText={inputText}
        disableTooltipText={{
            // если в кампании количество ообъявлений превышает лимит, то нельзя добавить ещё
            [SelectorItemsDisableReason.REACHED_COUNT_LIMIT]: i18n('banners-limit-in-campaign', {
                limit: itemsLimit
            })
        }}
        isActive={isActive}
    />
);
